var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRedX(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "61px",
    height: "61px",
    viewBox: "0 0 61 61",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Images / Failure X") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-2",
    transform: "translate(4.000000, 4.000000)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Partial-Timer",
    stroke: "#D0021B",
    strokeWidth: 8,
    fill: "#D0021B",
    cx: 26.5,
    cy: 26.5,
    r: 26.5
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-30",
    fill: "#FFFFFF",
    points: "39 15.9638889 37.0361111 14 26.5 24.5361111 15.9638889 14 14 15.9638889 24.5361111 26.5 14 37.0361111 15.9638889 39 26.5 28.4638889 37.0361111 39 39 37.0361111 28.4638889 26.5"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRedX);
export default __webpack_public_path__ + "static/media/red-x.99f890f6b3ab5f491cfb45cc087ac475.svg";
export { ForwardRef as ReactComponent };